import React, { FC } from 'react';
import { useTimeout } from 'react-use';

import classes from './KMeeple.module.scss';
import { colorMap } from '../ccson/CcsonPlayerItem';
import { MeepleDTO } from '@envclient/envengine/src/envs/tilebase/Meeple';
import { CSSPos } from '../../types/frontendTypes';

const KMeeple: FC<MeepleProps> = (props) => {
  const { meeple, pos, inMeepleCont, selected, onClick } = props;
  // place meeple animation (hook must run unconditionally, before any early return)
  const [isReady] = useTimeout(1);
  // nothing to render without a meeple (e.g. a bot-selected tax node before a meeple is attached)
  if (!meeple) return null;
  const { type, color, score, recovered } = meeple;

  // meeple/meepleBtn, giant/giantBtn, etc
  let meepleClass = classes[type];
  if (inMeepleCont) meepleClass = classes.meepleInCont + ' ' + classes[type + 'Btn'];

  const bgClassName = type + '_' + colorMap[color].name;
  const bgClass = classes[bgClassName];

  const bgStyle = {
    display: recovered ? 'none' : 'block'
  };

  const tfStyle = {
    backgroundColor: recovered ? '#000' : '#fff',
    color: recovered ? colorMap[color].code : '#000',
    display: score > 0 ? 'inline' : 'none'
  };

  const finalStyle: CSSPos = { ...pos, ...props.rotStyle };

  const handleClick = () => {
    onClick?.(meeple);
  };

  const startStyle: CSSPos = { top: -500, left: 500, ...props.rotStyle };

  return (
    <div className={meepleClass} style={selected && !isReady() ? startStyle : finalStyle} onClick={handleClick}>
      <div className={classes.bg + ' ' + bgClass} style={bgStyle}></div>
      <p className={classes.tf} style={tfStyle}>
        {score}
      </p>
    </div>
  );
};

interface MeepleProps {
  meeple: MeepleDTO;
  pos?: CSSPos;
  inMeepleCont?: boolean;
  selected?: boolean;
  onClick?: (meeple: MeepleDTO) => void;
  rotStyle: {
    transform?: string;
    transformOrigin?: string;
  };
}

export default KMeeple;
